/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { TDetailsNone, TFailArgs, TMaybeDetails, TOpts } from './types'

export const parseArgs = <Details extends TMaybeDetails = TDetailsNone>(
  args: TFailArgs<Details>,
): TOpts<Details> => {
  if (typeof args[0] === 'string') {
    return {
      ...(args[1] as TOpts<Details>),
      message: args[0],
    }
  }

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return {
    ...args[0],
  } as TOpts<Details>
}
